import React from 'react';
import PropTypes from 'prop-types';

import { NumberHelper } from '../../../../helpers/NumberHelper';
import { TextHelper } from '../../../../helpers/TextHelper';
import { ShippingOptionsByLocation } from '../../../../models/ShippingOptionsByLocation';
import styles from './SectionContent.css';

const IPropTypes = {
  sectionInfo: PropTypes.instanceOf(ShippingOptionsByLocation).isRequired,
};

const orderAgencyData = agencyData => (
  agencyData.sort((agencyDataOne, agencyDataTwo) => (
    agencyDataOne.name.localeCompare(agencyDataTwo.name)
  ))
);

const SectionContent = ({ sectionInfo }) => (
  <div>
    {
      !!sectionInfo.textHeader &&
      TextHelper.separateIntoParagraphs(sectionInfo.textHeader).map(line => (
        <p key={line}>
          {line}
        </p>
      ))
    }
    {
      sectionInfo.shippings.map(shipping => (
        <div key={shipping.name} className={styles.shippingContent}>
          <h2 className={styles.name}>{shipping.name}</h2>
          {
            TextHelper.separateIntoParagraphs(shipping.shippingTime).map(line => (
              <p key={line}>
                {line}
              </p>
            ))
          }
          {
            shipping.price === shipping.maxPrice ?
              <p>Precio: ${NumberHelper.localizeNumber(shipping.price)}</p> :
              <p>
                Precio: ${NumberHelper.localizeNumber(shipping.price)}
                &nbsp;a ${NumberHelper.localizeNumber(shipping.maxPrice)}
              </p>
          }
          {
            !!shipping.agencyData.length &&
            <React.Fragment>
              <p className={styles.agencyHeader}>Agencias Disponibles:</p>
              <ul>
                {
                  orderAgencyData(shipping.agencyData).map(agency => (
                    <li key={agency.name} className={styles.agencyText}>
                      {agency.name} - Piso: ${NumberHelper.localizeNumber(agency.extraCost)}
                    </li>
                  ))
                }
              </ul>
            </React.Fragment>
          }
        </div>
      ))
    }
    {
      !!sectionInfo.textFooter &&
      TextHelper.separateIntoParagraphs(sectionInfo.textFooter).map((line) => {
        if (!line.includes('-')) {
          return (
            <p key={line}>
              <u>{line}</u>
            </p>);
        }
        return (
          <p style={{ color: '#777777' }} key={line}>
            {line}
          </p>);
      })
    }
  </div>
);

SectionContent.propTypes = IPropTypes;

export { SectionContent };



// WEBPACK FOOTER //
// ./src/pages/information/shipping/section-content/SectionContent.jsx